import React, { useContext } from 'react';
import UserContext from '../../../../.././../../../../../common/utils/getContext';
import { API_SERVER_URL, SITE_URL } from '../../../../.././../../../../../common/utils/utils';
import { t } from '../../../../.././../../../../../common/components/T';
import { LangContext } from '../../../../.././../../../../../common/decorators/Language';
import css from './FinPasswordBlock.module.scss';
import FinPasswordTooltip from '../../../../.././../../../../../views/profile/components/FinPasswordTooltip/FinPasswordTooltip';
import { TooltipsContext } from '../../../../.././../../../../../common/decorators/Tooltips';
import FormInput from '../../../../../../../../../../widgets/form/components/form-input/FormInput/FormInput';
import { dataSender } from '../../../../.././../../../../../common/utils/router';
import classNames from 'classnames';

const FinPasswordBlock = ({ finPassError, setFormData, classes = {} }) => {
    const { translation } = useContext(LangContext) || {};
    // const { setFinLogin } = useContext(UserFinanceContext);
    const { tooltipFlags } = useContext(TooltipsContext);
    const { userToken, setAlertData, lang } = useContext(UserContext);
    const resetPassFunc = () => {
        dataSender(
            `${API_SERVER_URL}/api/v1/user/financial-password/recover`,
            'POST',
            { url: `${SITE_URL}/finpassword-reset` },
            (response) => {
                setAlertData({
                    type: 'success',
                    cont:
                        response?.data?.data?.message ||
                        t('officePackage-message-send', 'Отправлено письмо', '/store', translation)
                });
            },
            (data) => {
                if (!!data.errors && data.errors?.login?.length) {
                    setAlertData({
                        type: 'error',
                        cont: data.errors?.login[0]
                    });
                } else if (!!data.message) {
                    setAlertData({ type: 'error', cont: data.message });
                }
            },
            userToken,
            lang
        );
    };
    // const finPasswordBlockTitleClass = classes?.finPasswordBlockTitle?.rewrite
    //     ? classes?.finPasswordBlockTitle?.class
    //     : classNames(css.finPasswordBlockTitle, classes?.finPasswordBlockTitle?.class || '');
    const finPasswordBlockContentContainerClass = classes?.finPasswordBlockContentContainer?.rewrite
        ? classes?.finPasswordBlockContentContainer?.class
        : classNames(css.finPasswordBlockContentContainer, classes?.finPasswordBlockContentContainer?.class || '');
    const finPasswordBlockClass = classes?.finPasswordBlock?.rewrite
        ? classes?.finPasswordBlock?.class
        : classNames(css.finPasswordBlock, classes?.finPasswordBlock?.class || '');

    const finPasswordPaymentCartInputWrapper = classes?.finPasswordPaymentCartInputWrapper?.rewrite
        ? classes?.finPasswordPaymentCartInputWrapper?.class
        : classNames(css.finPasswordPaymentCartInputWrapper, classes?.finPasswordPaymentCartInputWrapper?.class || '');

    const finPassTooltipBlock = classNames(css.finPassTooltipBlock, classes?.finPassTooltipBlock?.class || '');

    const finPassTooltipBlockBtnForHide = classNames(
        css.finPassTooltipBlockBtnForHide,
        classes?.finPassTooltipBlockBtnForHide?.class || ''
    );

    return (
        <div className={finPasswordBlockClass}>
            {/* <div className={finPasswordBlockTitleClass}>
                {t('FinPassword-title', 'Для подтверждения укажите ваш финансовый пароль', '/store', translation)}
            </div> */}
            <div className={finPasswordBlockContentContainerClass}>
                <FormInput
                    autocomplete={'new-password'}
                    setFormData={setFormData}
                    title={{
                        body: t(
                            'officePackageFinancialPassword-placeholder-commonBlock',
                            'Финансовый пароль',
                            '/store',
                            translation
                        )
                    }}
                    attribute='financial_password'
                    info={
                        <div className={css.financePassInfo}>
                            <p>
                                {t('FinPassword-title', 'Для подтверждения укажите ваш финансовый пароль', '/store', translation)}
                            </p>
                            <p className={css.infoHint} onClick={resetPassFunc}>
                                {t('cartPaymentFinancialPasswordRecoverCommonBlock-v1', 'Забыли пароль?', '/store', translation)}
                            </p>
                        </div>
                    }
                    type='password'
                    sender={() => {}}
                    errors={finPassError}
                    compStyle={{
                        hint: {
                            icon: { fill: 'blue' }
                        },
                        inputError: css.financePassInputError,
                        wrapper: finPasswordPaymentCartInputWrapper
                    }}
                />
                {tooltipFlags?.finPassTooltip ? (
                    <FinPasswordTooltip
                        classes={{
                            finPassTooltipBlock: finPassTooltipBlock,
                            finPassTooltipBlockBtnForHide
                        }}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default FinPasswordBlock;
